import { SelectInput } from '../../controls/select-input';
import { FieldWrapper, FieldWrapperProps } from './field-wrapper';
import { useController, UseControllerProps, FieldValues } from 'react-hook-form';
import { SelectOptions } from 'ts-types';

export interface SelectFieldProps<T extends FieldValues, V = string>
  extends UseControllerProps<T>,
    Pick<FieldWrapperProps, 'label' | 'labelSize' | 'required' | 'showError'> {
  values: SelectOptions<V, string>[];
  isSmallSize?: boolean;
  disabled?: boolean;
  showEmptyOption?: boolean;
}

export const SelectInputField = <T extends FieldValues, V = string>({
  label,
  values,
  required,
  isSmallSize = false,
  labelSize = 'l',
  showError,
  disabled,
  showEmptyOption = true,
  ...props
}: SelectFieldProps<T, V>) => {
  const {
    field,
    fieldState: { error }
  } = useController(props);
  return (
    <FieldWrapper label={label} error={error} labelSize={labelSize} showError={showError} required={required}>
      <SelectInput
        values={values}
        error={error}
        {...field}
        required={required}
        isSmallSize={isSmallSize}
        disabled={disabled}
        showEmptyOption={showEmptyOption}
      />
    </FieldWrapper>
  );
};
